import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

// CSS
import './App.css';

// Context
import { CartProvider } from './context/CartContext';

// Pages
import Home from './pages/Home/Home';
import Menu from './pages/Menu/Menu';
import MenuRedirect from './pages/Menu/MenuRedirect';
import Order from './pages/Order/Order';

// Components
import Layout from './components/Layout/Layout';
import Custom from './pages/Custom/Custom';
import Mango from './pages/Mango/Mango';

// Create a component to track route changes
const AppContent = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view whenever route changes
    if (window.fbq) {
      window.fbq('track', 'PageView');
    }
  }, [location]);

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/menu" element={<MenuRedirect />} />
        <Route path="/menu/:slug" element={<Menu />} />
        <Route path="/order" element={<Order />} />
        <Route path="/custom" element={<Custom />} />
        <Route path="/mango" element={<Mango />} />
      </Routes>
    </Layout>
  );
};

const App = () => {
  return (
    <CartProvider>
      <Router>
        <AppContent />
      </Router>
    </CartProvider>
  );
};

export default App;